import React, { Fragment, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { DeleteDeposit, DoDeposit, GetExchangeData, GetPointHistory } from '../../common/actions/moreAction';
import Pagenation from '../common/Pagenation';
import NavLink from 'react-router-dom/NavLink';
import DepositDetailsContentElse from './DepositDetailsContentElse';
import WithdrawalDetailsContentElse from './WithdrawalDetailsContentElse';
import { dateFormation, isEmpty } from '../../common/cores';
import {__, __f} from '../../utils/i18nUtils';

const PointHistoryContent = (props) => {

    const [money, setMoney] = useState(0);
    const [showHis, setShowHis] = useState(false);

    const lists = props.pointexchange.data;
    const { page, user, pointHistory } = props;
    let ids = [];
    const [type, setType] = useState(1);
    const onResetType = (val) => {
        setType(val)
    };

    const getLists = (page) => {
        props.GetPointHistory(page);
    }
    console.log(lists)
    if (user.isAuthenticated == false) {
        window.location.href = "/login"
    }


    useEffect(() => {
        getLists();
    }, [props.user.isAuthenticated, props.page.perPage])

    return (
        <Fragment>
            <div className="con_box10">
                <div className="how_point">
                    <ul>
                        <li>포인트내역</li>
                    </ul>
                </div>
            </div>
            <div className="con_box10">
                <table width="100%" border="0" cellSpacing="0" cellPadding="0" style={{ borderSpacing: "0" }}>
                    <tbody>
                        <tr>
                            <td width="10%" className="list_title1">번호</td>
                            <td width="10%" className="list_title1">사용포인트</td>
                            <td width="10%" className="list_title1">이전포인트</td>
                            <td width="10%" className="list_title1">보유포인트</td>
                            <td width="10%" className="list_title1">내용</td>
                            <td width="10%" className="list_title1">상세내용</td>
                            <td width="10%" className="list_title1">처리일자</td>
                        </tr>
                        {
                              pointHistory.map((history, index) => {
                                return (
                                    <tr key={index}>
                                        <td className="list1">{isNaN(page.curPage) ? 0 : (page.curPage - 1) * 10 + index + 1}</td>
                                        <td className={`list1 text ${(history.amount.rolling > 0) ? "blue-color" : "red-color"}`}> { isEmpty(history.amount.rolling) ? 0 : Number(history.amount.rolling).toLocaleString()}</td>
                                        <td className="list1">{((isEmpty(history.balance.rolling) ? 0 : Number(history.balance.rolling)) - (isEmpty(history.amount.rolling) ? 0 : Number(history.amount.rolling))).toLocaleString()}</td>
                                        <td className="list1"> {isEmpty(history.balance.rolling) ? 0 : Number(history.balance.rolling).toLocaleString()}</td>
                                        <td className="list1"> {__f(history.memo.title)}</td>
                                        <td className="list1">{__f(history.memo.description)}</td>
                                        <td className="list1">{dateFormation(history.date, 8)}</td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
            </div>
            <Pagenation page={page.curPage}
                totalPage={page.totalPage}
                getPage={getLists}
                perPage={10} />
        </Fragment>

    );
};

const mapStateToProps = state => ({
    user: state.user,
    pointexchange: state.more.pointexchange,
    page: state.page,
    pointHistory: state.more.pointHistory,
})

export default connect(mapStateToProps, { GetExchangeData, DoDeposit, DeleteDeposit, GetPointHistory })(PointHistoryContent);


// WEBPACK FOOTER //
// ./src/components/account/PointHistoryContent.js